module.exports = __webpack_public_path__ + "static/media/x-trail-hero.4705b364.webp";